export default "__VITE_ASSET__IgIW1_Tm__"